import { useContext } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { UserContext } from "../../logic/auth/user-context";
import { useNavigate } from "react-router-dom";
import { useEffectiveOrgId } from "../../logic/auth/use-effective-org-id";

/**
 * Lets a user switch which of their organizations they are viewing. The list
 * comes from the orgs the user may access (user.organizations); selecting one
 * sends it as the active org on subsequent requests. Shown to any user who
 * belongs to more than one org (including super users, who can access all).
 */
export const OrgPicker: React.FC = () => {
  const userContext = useContext(UserContext);
  const effectiveOrgId = useEffectiveOrgId();
  const navigate = useNavigate();
  const orgs = userContext.user.organizations ?? [];

  const idPrefix = "active-org-";
  const inputLabelId = idPrefix + "label";

  return (
    <FormControl size="small" fullWidth={true}>
      <InputLabel id={inputLabelId} color="secondary">
        Account
      </InputLabel>
      <Select
        labelId={inputLabelId}
        id={idPrefix + "select"}
        value={effectiveOrgId}
        label="Account"
        onChange={(e) => {
          const org = orgs.find((org) => org.id === e.target.value);

          if (org === undefined) {
            throw new Error("Org not found");
          }

          userContext.setActiveOrg(org);
          navigate("/");
        }}
      >
        {orgs.map((org) => (
          <MenuItem key={org.id} value={org.id}>
            {org.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
